

import { ReactComponent as QrIcon } from './../../../assets/images/icons/qr.svg';


export const Warning = () => {
    return (
        <div className="container d-flex align-items-center justify-content-center text-center mt-5">
        <div className="row align-items-center justify-content-center">
            <div className="col-auto">
                <QrIcon style={{height: '100px'}}/>
            </div>
            <div className="w-100 mt-3"></div>
            <div className="col-auto">
                <p className="h4">Шановний Клієнт</p>
                <p className="h5">Для того щоб отримати доступ до меню закладу, будь-ласк увімкніть камеру або додаток сканування QR-коду та відскануйте QR на столі.</p>
            </div>
            <div className="w-100 mt-3"></div>
        </div>
    </div>
    );
};
